import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { MatAngularModule } from '../../modules/mat-angular.module';
import { BrandIndexService } from '../../../services/brand-index.service';
import { AuthService, User } from '../../../services/auth.service';
import { Subscription } from 'rxjs';
import { CommonService } from '../../../services/common.service';
import { NotificationBellComponent } from '../notification-bell/notification-bell.component';

@Component({
  selector: 'app-version-nav',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatAngularModule,
    NotificationBellComponent
  ],
  templateUrl: './version-nav.component.html',
  styleUrl: './version-nav.component.scss'
})
export class VersionNavComponent implements OnDestroy {
  dashboardTitle: string = 'AI Analytics Platform';
  showDashboardHeader: boolean = false;
  currentUser: User | null = null;
  private routerSubscription: Subscription;

  constructor(
    private brandIndexService: BrandIndexService,
    private authService: AuthService,
    private router: Router,
    private commonService: CommonService
  ) {
    this.checkRoute();
    this.loadUserProfile();
    // Listen for route changes
    this.routerSubscription = this.router.events.subscribe(() => {
      this.checkRoute();
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private checkRoute(): void {
    const currentUrl = this.router.url;

    // Check which route we're on
    if (currentUrl === '/' || currentUrl === '') {
      this.dashboardTitle = 'AI Analytics Platform';
      this.showDashboardHeader = false;
    } else if (currentUrl.includes('/common-ai-analysis/education')) {
      this.dashboardTitle = 'AI Analysis Dashboard';
      this.showDashboardHeader = true;
    } else if (currentUrl.includes('/dashboard')) {
      this.dashboardTitle = 'Dashboard';
      this.showDashboardHeader = true;
    } else if (currentUrl.includes('/about') || currentUrl.includes('/terms') || 
               currentUrl.includes('/privacy') || currentUrl.includes('/cookie-policy')) {
      // Legal pages - show header
      this.dashboardTitle = 'AIOptima';
      this.showDashboardHeader = true;
    } else {
      this.dashboardTitle = 'Brand Analysis Dashboard';
      this.showDashboardHeader = true;
    }
  }

  private loadUserProfile(): void {
    this.currentUser = this.authService.getCurrentUser();
  }

  navigateToEducation(type: string): void {
    if (type === 'education-university') {
      this.router.navigate(['/common-ai-analysis/education/university']);
    } else if (type === 'education-student') {
      this.router.navigate(['/common-ai-analysis/education/student']);
    }
  }

  getGreeting(): string {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 17) return 'Good Afternoon';
    return 'Good Evening';
  }

  // Role-based navigation methods
  canAccessUserManagement(): boolean {
    return this.authService.canAccessUserManagement();
  }

  canAccessRoleManagement(): boolean {
    return this.authService.canAccessRoleManagement();
  }

  canAccessProjectManagement(): boolean {
    return this.authService.canAccessProjectManagement();
  }

  isMember(): boolean {
    return this.authService.isMember();
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  isUniversity(): boolean {
    return this.authService.isUniversity();
  }

  isGenericFlowActive(): boolean {
    return this.commonService.isGenericFlowActive();
  }

  logout() {
    // Clear authentication data
    this.authService.logout();

    // Clear any additional brand-related data
    this.brandIndexService.removeLocalStorageData();

    // Navigate to login page
    this.router.navigate(['/login']);
  }
}
